export const LOADING_KEYS = {
  ASSESSMENT_NOTE: "assessmentNote",
  INDIVIDUAL_PATIENT: "individualPatient",
  TREATMENT_KEY: "treatmentKey",
  WOUND_EVENTS_ACTIVITY_LOG: "woundEvent",
  ADT_EVENTS_ACTIVITY_LOG: "adtEvents",
  VIEW_EVENTS_ACTIVITY_LOG: "viewEvent",
  DELETE_ASSESSMENT_NOTE: "deleteAssessmentNote",
  CREATE_NOTE: "CREATE_NOTE",
  UPDATE_NOTES: "UPDATE_NOTES",
  INTERVENTION_TREATMENT: "interventionTreatment",
  HEALING_TRAJECTORY: "healingTrajectory",
  PATIENT_V1: "PATIENT_V1",
  PATIENT_REFUSAL_REASON: "PATIENT_REFUSAL_REASON",
  GET_ASSESSMENT_HISTORY: "GET_ASSESSMENT_HISTORY",
  GET_CONSOLIDATE_PDF: "GET_CONSOLIDATE_PDF",
  GET_MINIMUM_DATASET_INFO: "GET_MINIMUM_DATASET_INFO",
  SIGN_LOCK_LOADING: "SIGN_LOCK_LOADING",
  // Report
  QUALITY_ASSURANCE_REPORT: "qualityAssuranceReport",
  QUALITY_ASSURANCE__CSV_REPORT: "qualityAssuranceCsvReport",
  TREATMENT_REPORT: "treatmentReport",
  TREATMENT_CSV_REPORT: "treatmentCsvReport",
  WOUND_DASHBOARD_ASSESSMENT: "woundDashboardAssessment",
  QUALITY_ASSURANCE_OVERVIEW: "qualityAssuranceOverview",
  CSV_EXPORT: "csvExport",
  BI_REPORT_LIST: "biReportList",
  NEW_ADDMISSION_POA: "newAdmissionPOA",
  NEW_ADDMISSION_NONPOA: "newAdmissionNonPOA",
  NEW_WOUNDS_POA: "newWoundsPoa",
  NEW_WOUNDS_NON_POA: "newWoundsNonPoa",
  PI_ASSESSMENT_POA: "piAssessmentPOA",
  PI_ASSESSMENT_NON_POA: "piAssessmentNonPOA",
  OTHER_ASSESSMENT_POA: "OTHER_ASSESSMENT_POA",
  OTHER_ASSESSMENT_NON_POA: "OTHER_ASSESSMENT_NON_POA",
  WOUND_EXPERT_ASSESSMENT_POA: "WOUND_EXPERT_ASSESSMENT_POA",
  WOUND_EXPERT_ASSESSMENT_NON_POA: "WOUND_EXPERT_ASSESSMENT_NON_POA",
  WOUND_EXPERT_ASSESSMENT_DEBRIDEMENT: "WOUND_EXPERT_ASSESSMENT_DEBRIDEMENT",
  COMPLETED_ASSESSMENT: "COMPLETED_ASSESSMENT",
  WOUND_PHOTO_WORKLIST: "WOUND_PHOTO_WORKLIST",
  SURVERY_RESULTS: "SURVERY_RESULTS",
  USER: "USER",
  SSO_TENANT_LIST: "SSO_TENANT_LIST",
  GET_FORMULARY: "GET_FORMULARY",
  GET_LAYOUTS: "GET_LAYOUTS",
  GET_CUSTOM_FORM: "GET_CUSTOM_FORM",
  GET_CUSTOMER: "GET_CUSTOMER",
  GET_SUPPORT: "GET_SUPPORT",
  GET_ANNOUNCEMENT: "GET_ANNOUNCEMENT",
  GET_ASSIGNED_FORMULARY: "GET_ASSIGNED_FORMULARY",
  GET_CUSTOMER_USERS: "GET_CUSTOMER_USERS",

  //home
  CREATE_RISK_ASSESSMENT: "CREATE_RISK_ASSESSMENT",
  SAVE_RISK_ASSESSMENT: "SAVE_RISK_ASSESSMENT",
  GET_RISK_ASSESSMENT: "GET_RISK_ASSESSMENT",
  GET_RISK_ASSESSMENT_BY_ID: "GET_RISK_ASSESSMENT_BY_ID",
  EMAIL_RECOMMENDED_PRODUCT: "EMAIL_RECOMMENDED_PRODUCT",
  GET_SKIN_HEALTH_PRODUCTS: "GET_SKIN_HEALTH_PRODUCTS",
  GET_SKIN_HEALTH_PRODUCTS_PAGINATION: "GET_SKIN_HEALTH_PRODUCTS_PAGINATION",
  GET_PRODUCT_MASTER_BY_ID: "GET_PRODUCT_MASTER_BY_ID",
  EMAIL_CONTACT_SALE_REP: "EMAIL_CONTACT_SALE_REP",
  GET_PRODUCT_MASTER_MATERIAL_BY_ID: "GET_PRODUCT_MASTER_MATERIAL_BY_ID",
  PRODUCT_NOT_FOUND_EMAIL: "PRODUCT_NOT_FOUND_EMAIL",
  SEARCH_BY_PRODUCT_DIVISION: "SEARCH_BY_PRODUCT_DIVISION",
  GET_FORMULARY_FACILITIES: "GET_FORMULARY_FACILITIES",
  GET_RECOMMENDED_PROTEIN: "GET_RECOMMENDED_PROTEIN",
  GET_SUPPLEMENT_PROTEIN: "GET_SUPPLEMENT_PROTEIN",
  CREATE_TABLE_PADS: "CREATE_TABLE_PADS",
  PRODUCT_SELECTOR_QUESTION: "PRODUCT_SELECTOR_QUESTION",
  GET_RECOMMENDED_PRODUCT_COUNT: "GET_RECOMMENDED_PRODUCT_COUNT",
  GET_RECOMMENDED_PRODUCT_DETAIL: "GET_RECOMMENDED_PRODUCT_DETAIL",
  NON_PAID_REQUEST_DEMO: "NON_PAID_REQUEST_DEMO",

  UPDATE_CUSTOMER: "UPDATE_CUSTOMER",
};
